import { render } from "./UserStatisticView.vue?vue&type=template&id=34786eb0&scoped=true"
import script from "./UserStatisticView.vue?vue&type=script&lang=js"
export * from "./UserStatisticView.vue?vue&type=script&lang=js"

import "./UserStatisticView.vue?vue&type=style&index=0&id=34786eb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34786eb0"]])

export default __exports__